import React, {Component} from 'react'
import {Image} from 'react-konva';
import './stage.css';

/** @class ImageLayer
 * Renders a positioned image on the stage.
 */
export default class ImageLayer extends Component {
  /** @constructor
    * Creates a new instance of ImageLayer
    * @prop {url} image - the image to display on stage
    * @prop {number} x - the horizontal position of the image on stage
    * @prop {number} y - the vertical position of the image on stage
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
  }
  /** @method componentWillMount
    * Loads the image.
    */
  componentWillMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
      console.log('image': image)
    }
    image.src = this.props.image;
  }
  /** @function
   * Renders the image.
   */
  render() {
    return (
      <Image
        image={this.state.image}
        x={this.props.x}
        y={this.props.y}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage/image-layer.js